<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de Entrada">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/almoxarifado/relatorio-entrada/List'

export default {
    components: { List },
}
</script>
